import React from 'react'
import { Controller } from 'react-hook-form'
import InputField from './InputField'

// required props: 
// {
//     name, // string
//     control, // control-object-react-hook-form
//     label, // string
//     error, // boolean
//     helperText, // string
//     showLabel, // boolean
// }

const InputController = ({
    name, // Input name, id(if not provided)
    control, // react-hook-form control
    label, // Input Label, aria-label
    error, // Is there Error? (true/ false)
    helperText, // Helper Text
    showLabel, // Show Label or not
    required,
    ...props // All other props
}) => {
  return (
    // Controller from react-hook-form
    <Controller
        name={name}
        control={control}
        defaultValue={props.defaultValue || ""}
        render={({ field }) => (
          // Our custom InputField(mui)
            <InputField
                {...field} // Spread the field object
                showLabel={showLabel}
                id={name} // Set unique id based on name
                label={label} // Label
                error={error} // Pass error state
                helperText={helperText} // Pass helper text
                required={required}
                {...props} // Other props
            />
        )}
    />
  )
}

export default React.memo(InputController)